import { Component } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';

@Component({
  selector: 'app-qn-sbn-eservice',
  standalone: true,
  imports: [OneWebComponentsAngularModule],
  templateUrl: './qn-sbn-eservice.component.html',
  styleUrl: './qn-sbn-eservice.component.scss'
})
export class QnSbnEserviceComponent {

}
